export default "/staticreactui/static/media/static/media/customer3.b298eb7a.png";